<template>
  <div id="DepreciationNBVAsAt">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Depreciation NBV As At</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'depreciationNBVReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'depreciationNBVReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  ref="depreciationNBVTable"
                  mode="remote"
                  title="depreciationNBV"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "DepreciationReview",
  metaInfo() {
            return {title: "Depreciation NBV As At | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:
    [
      {
          label: 'Unit Number',
          field: 'unit_no',
          filterable: true,
          hidden:false,
          fpFieldType:"text",
      },
      {
          label: 'Company',
          field: 'company',
          filterable: false,
          sortable: false,
          hidden:false,
          fpFieldType:"option",
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Company", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['000','001','002'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Current Unit Sts',
          field: 'unit_status',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Current Sched Sts',
          field: 'schedule_status',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit Current Sts", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Active','Closed'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Sched Type',
          field: 'schedule_type',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Depr. Start Date',
          field: 'start_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Depr. End Date',
          field: 'last_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Cap Cost',
          field: 'capital_amount',
          fpFieldType:"integer",
          type: 'number',
          filterable: true,
          hidden:false,
      },
      {
          label: 'Accum. Depr.',
          field: 'accumulated_depreciation',
          fpFieldType:"integer",
          type: 'number',
          filterable: true,
          hidden:false,
      },
      {
          label: 'NBV',
          field: 'net_book_value',
          fpFieldType:"integer",
          type: 'number',
          filterable: true,
          hidden:false,
      },
      {
          label: 'Depr Posted This Period',
          field: 'dep_posted',
          fpFieldType:"integer",
          type: 'number',
          filterable: true,
          hidden:false,
        //   sortable:false
      },
      {
          label: 'Residual',
          field: 'residual',
          fpFieldType:"integer",
          type: 'number',
          filterable: true,
          hidden:false,
      },
      {
          label: 'Expected Life',
          field: 'duration',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Remaining Months',
          field: 'remaining_month',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Owner',
          field: 'ownership',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
       {
          label: 'Description',
          field: 'description',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Purchase Date',
          field: 'purchase_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'In Service',
          field: 'date_in_service',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Serial Nbr',
          field: 'vin',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Group',
          field: 'group',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Equip Type',
          field: 'asset_type',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Make',
          field: 'make',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Model',
          field: 'model',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Year',
          field: 'year',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Pool',
          field: 'pool',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Current Contract',
          field: 'conType',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Current Customer',
          field: 'cust_code',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Customer Name',
          field: 'cust_name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Disposal Date',
          field: 'disposal_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Last Posted',
          field: 'last_posted',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Financier Code',
          field: 'fin_code',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Note Reference',
          field: 'note',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 1 Rdg',
          field: 'reading1',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 1 Date',
          field: 'reading_date1',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 2 Rdg',
          field: 'reading2',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 2 Date',
          field: 'reading_date2',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 3 Rdg',
          field: 'reading3',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Metric 3 Date',
          field: 'reading_date3',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
       {
          label: 'Period End Date',
          field: 'period_end',
          fpFieldType:"custom_date",
          filterable: false,
          sortable:false,
          fpMandatory:true,
          hidden:true,
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'depreciation_nbv') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.depreciationNBVTable.unselectAllInternal();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['depreciationNBVTable'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['depreciationNBVTable'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/depreciation-nbv-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }

          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'depreciation-nbv-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/DepreciationNBVAsAt.vue